import {
  SET_ACTIVE_CONTACT,
} from '../actions';

export default function (state = {}, action) {

  switch(action.type) {
    case SET_ACTIVE_CONTACT:
      return action.payload;

    default:
      return state;
  }
}